import { useCallback } from 'react';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackManufacturerPackagePageGotoSearchEventData } from './legacy-types';

export const createLegacyTrackManufacturerPackagePageGotoSearch = (
  buttonLocation: 'top' | 'bottom',
  resellerPackageName: string,
): LegacyTrackManufacturerPackagePageGotoSearchEventData => {
  const eventData: LegacyTrackManufacturerPackagePageGotoSearchEventData = {
    eventType: 'manufacturerPackagePageGotoSearch',
    information: {
      buttonLocation,
      resellerPackageName,
    },
  };

  return eventData;
};

export const useLegacyTrackManufacturerPackagePageGotoSearch = () => {
  const { track } = useLegacyTracking();

  const trackLegacyManufacturerPackagePageGotoSearch = useCallback(
    (buttonLocation: 'top' | 'bottom', resellerPackageName: string) => {
      track({
        event: 'manufacturerPackagePageGotoSearch',
        data: createLegacyTrackManufacturerPackagePageGotoSearch(
          buttonLocation,
          resellerPackageName,
        ),
      });
    },
    [track],
  );

  return {
    trackLegacyManufacturerPackagePageGotoSearch,
  };
};
